import * as actionTypes from '../Actions/actionTypes';
import * as actionTdi from '../../Application/Components/TDIObject/tdiobjectActions';

//import { loginReturn } from '../../Application/Components/Login/loginActions';

// Application State
const initialState = {
    isConnected:false,
    session:null,
    sessionId:null,
    isLogged: false,
    loginMessage:"",
    globalData:{TDI:null},
    TDI:[],
    tasks:[],
    workingData:[],
    loadedObject:null,
    newObject:null,
    listOptions:null,
    canLoadMore:true,
    pageNumber:0,
    server: { Name: "SodeSoft", Status: "Unavailable" },
    transfertObject:{
        FLAG:0,
        ObjDataDto:null,
        ObjDatasCibleDto:null,
        ObjDatasSourceDto:null,
        ObjParamDto:{
            ARCS:0,
            CODE:'',
            Locked:0,
            ETAT:0,
            SV:0,
            CD:'',
            LNH:'L',
            RecordFlag:'ALL',
            SessionIDE:"",
            sPageFilter:"",
            bPageIsActive:true,
            iPageNumber:0,
            iPageWeigth:40,
            iPageSort:"",    
        },
        ObjParamsDto:{
            ARCS_PER:0,
            ARCS_TP_N3:0,
            CD:"",
            DestroyCol:0,
            LNH:'L',
            RecordFlag:'ALL',
            SV:0,
            SessionIDE:"",
            ToIUD:0,
            sPageFilter:"",
            bPageIsActive:true,
            iPageNumber:0,
            iPageWeigth:40,
            iPageSort:"",
        },
        Session:{
            Application:"REASSURANCE",
            CodeApplication:4,
            Session:null
        },
        objFile:null,
        vntIndexKey:0
    },
    blankObjects: {
        TDI : {
            AC_001: 0,
            ARCS: 0,
            CODE: "",
            ENTITY: "",
            FLAG: 0,
            HISTORIQUE: 0,
            IU: "",
            NSYS: 4,
            SIT: 0,
            Session: {},
            SessionIDE: "",
            Status: 0,
            WORDING: "",
        },
        EN3 : {
            AC_001: 0,
            ARCS: 0,
            ARCS_PER: 0,
            ARCS_TP_N3: 0,
            CODE: "",
            COMMENT: "",
            FLAG: 0,
            HISTORIQUE: 0,
            IU: "R",
            NSYS: 4,
            SIT: 0,
            Session: {},
            SessionIDE: "",
            Status: 0,
            WORDING: "",
        },
        PAYS :{
            AC_001: 0,
            ARCS: 0,
            CAPITAL: "",
            CONTINENT_ARCS: 0,
            DOMAINE: ".    ",
            FILE: [],
            FLAG: 0,
            HISTORIQUE: 0,
            INDICATIF: "+    ",
            ISO_3166_1: 0,
            ISO_3166_1_ALPHA2: "",
            ISO_3166_1_ALPHA3: "",
            IU: "R",
            NSYS: 4,
            SIT: 0,
            SUPERFICIE_KM2: 0,
            Session: {},
            SessionIDE: "",
            Status: 0,
            WORDING: "",
        },
        LNK :{
            AC_001: 0,
            ARCS: 0,
            CHILD_FIELD: "",
            CHILD_TABLE: "",
            CODE_TDI: "",
            FLAG: 0,
            HISTORIQUE: 0,
            IU: "R",
            NSYS: 4,
            PARENT_FIELD: "",
            PARENT_TABLE: "",
            SIT: 0,
            Session: {},
            SessionIDE: "",
            Status: 0,
        },
        CUR:{
            AC_001:0,
            ARCS:0,
            //....//
        },
        DOC:{
            ARCS:0,
            PER_ARCS:2,
            CODE_02:0,
            TP_NN:0,
            Locked:0,
            CD:"",
            SV:0,
            LNH:"ALL",
            ETAT:0,
        }
        
    },
}

const openSessionReturns = (state, action) => {
    if(action.data.response.data ===111){
        state.server.Status = "Available";
        state.session = action.data.sessionReact;
        state.sessionId = action.data.sessionReact.Session.SESSION_ID;
    }else{
        state.isConnected = false;
        state.server.Status = "Unavailable";
        state.isLogged = false;
    }

    return { ...state };
}

const postReturns = (state,action) =>{
    console.log("data page",action.data.page)
    if(action.data.page >0){
        state.workingData.push.apply(state.workingData, action.data.list);
    }else{
        state.workingData = action.data.list;
    }
    
    return { ...state };
}
const getListOptionsReturn = (state,action) =>{
    state.listOptions = action.data;
    return { ...state };
}

const postEN3Returns = (state, action) => {
    state.globalData.EN3 = action.data;
    return { ...state };
}

const updateLoginReturn = (state, action) => {
    if(action.data){
        state.isConnected = true;
        state.isLogged = true;
    }else{
        state.isConnected = false;
        state.isLogged = false;
        state.loginMessage = "Invalid credential, please double check your username, password or domain.";
    }
    return { ...state };
}

//-------------- API  ----------------
const updateTDIReturn = (state, action) => {
    state.TDI = action.data;
    return {...state};
}
const postNoReturns = (state, action) => {
    state.workingData = [];
    return { ...state };
}

const initLoadedObject = (state,action)=>{
    state.loadedObject = action.data;
    state.newObject = action.data;
    
    return {...state};
}
const releaseLoadedObject = (state,action)=>{
    state.loadedObject = null;
    state.listOptions = null;
    return {...state};
}

const onUpdateObjectFromForm = (state,action)=>{
    var stateTmp = {...state};
    var objectTMP = {...stateTmp.newObject};
    
    if(action.data.columnName === "WORDING" && typeof(objectTMP[action.data.columnName]) === "object"){
        objectTMP[action.data.columnName][action.data.language] = action.data.value;
    }else{
        objectTMP[action.data.columnName] = action.data.value;
    }
    stateTmp.newObject = objectTMP;
    
    return stateTmp;
}

const cleanFormData = (state,action) =>{
    var stateTmp = {...state};
    stateTmp.newObject= null;
    stateTmp.loadedObject=null;
    return stateTmp;
}

const addMocks = (state,action) =>{
   
    var stateTmp = {...state};
    stateTmp.workingData = action.data;
    return stateTmp;
}
// PAGINATION
const onNoMoreRecord = (state,action) =>{
    var stateTmp = {...state};
    stateTmp.canLoadMore = false;
    return stateTmp;
}

const onResetPagination = (state,action) =>{
    state.canLoadMore = true;
    state.pageNumber = 0;
    console.log("pagination reseted");
    return {...state};
}

const onUpdateSession = (state,action)=>{
    state.transfertObject.Session = action.data;
    state.transfertObject.ObjParamsDto.SessionIDE = action.data.Session.SESSION_ID;
    state.transfertObject.ObjParamDto.SessionIDE = action.data.Session.SESSION_ID;
    return {...state};
}

const updateTasks = (state,action)=>{
    state.tasks = action.data;
    return {...state};
}

const apiReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.OPEN_SESSION_RETURN:
            return openSessionReturns(state,action);
        case actionTypes.POST_RETURN:
            return postReturns(state,action);
        case actionTypes.POST_NO_RETURN:
            return postNoReturns(state,action);
        case actionTdi.POST_EN3_RETURN:
            return postEN3Returns(state,action);
        case actionTypes.POST_TDI_RETURN:
            return updateTDIReturn(state,action);
        case actionTypes.LOGIN_RETURN:
            return updateLoginReturn(state,action);
        case actionTypes.GET_OBJECT_RETURN:
            return initLoadedObject(state,action);
        case actionTypes.GET_OBJECTS_RETURN:
            return postReturns(state,action);
        case actionTypes.GET_LIST_OPTIONS_RETURN:
            return getListOptionsReturn(state,action);
        case actionTypes.SAVE_OBJECT_RETURN:
            return releaseLoadedObject(state,action);
        case actionTypes.CLEAN_LOADED_OBJECT:
            return releaseLoadedObject(state,action);
        case actionTypes.UPDATE_FROM_FORM:
            return onUpdateObjectFromForm(state,action);
        case actionTypes.CLOSE_FORM:
            return cleanFormData(state,action);
        case actionTypes.INIT_MOCK:
            return addMocks(state,action);
        case actionTypes.UPDATE_TASKS:
            return updateTasks(state,action);
        case actionTypes.UPDATE_SESSION:
            return onUpdateSession(state,action);
        // PAGINATION
        case actionTypes.RESET_PAGINATION:
            return onResetPagination(state,action);
        case actionTypes.NO_MORE_RECORD:
            return onNoMoreRecord(state,action);
        default:
            return {...state};
    }
}


export default apiReducer;
